import React, { useState, useRef } from 'react';
import { ScanLineIcon, AlertCircleIcon, QrCodeIcon } from 'lucide-react';
interface StorageScannerProps {
  onScanComplete: (locationCode: string) => void;
}
export function StorageScanner({
  onScanComplete
}: StorageScannerProps) {
  const [scannedCode, setScannedCode] = useState('');
  const [scanSuccess, setScanSuccess] = useState<boolean | null>(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [isScanning, setIsScanning] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const handleScan = () => {
    if (!scannedCode) {
      setErrorMessage('Bitte geben Sie einen QR-Code ein oder scannen Sie ihn');
      setScanSuccess(false);
      return;
    }
    setIsScanning(true);
    // Simuliere den Scanvorgang mit einer kurzen Verzögerung
    setTimeout(() => {
      // Validiere, ob der gescannte Code ein gültiger Lagerplatz-Code ist
      // Für die Demo akzeptieren wir einfach alle Codes, die mit "TKL" beginnen
      const isValid = scannedCode.startsWith('TKL') || scannedCode.toUpperCase().startsWith('TKL');
      setScanSuccess(isValid);
      if (isValid) {
        setErrorMessage('');
        // Normalisiere den Code für die weitere Verarbeitung
        const normalizedCode = scannedCode.toUpperCase();
        setTimeout(() => {
          onScanComplete(normalizedCode);
        }, 1000);
      } else {
        setErrorMessage('Der gescannte Code ist kein gültiger Lagerplatz-Code. Gültige Codes beginnen mit "TKL".');
      }
      setIsScanning(false);
    }, 1000);
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleScan();
    }
  };
  return <div className="bg-white rounded-xl shadow-md p-8" data-id="element-2001">
      <div className="max-w-md mx-auto text-center mb-8" data-id="element-2002">
        <div className="bg-blue-100 p-4 rounded-full inline-flex mb-4" data-id="element-2003">
          <QrCodeIcon size={48} className="text-blue-600" data-id="element-2004" />
        </div>
        <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2005">
          Lagerplatz scannen
        </h3>
        <p className="text-gray-600" data-id="element-2006">
          Bitte scannen Sie den QR-Code des Lagerplatzes, um fortzufahren.
        </p>
      </div>
      <div className="max-w-md mx-auto" data-id="element-2007">
        <div className="mb-6" data-id="element-2008">
          <div className="flex gap-2" data-id="element-2009">
            <div className="flex-1 relative" data-id="element-2010">
              <input ref={inputRef} type="text" className={`block w-full pl-10 pr-3 py-3 border ${scanSuccess === true ? 'border-green-500 bg-green-50' : scanSuccess === false ? 'border-red-500 bg-red-50' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`} placeholder="QR-Code scannen oder eingeben..." value={scannedCode} onChange={e => setScannedCode(e.target.value)} onKeyDown={handleKeyDown} autoFocus data-id="element-2011" />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2012">
                <ScanLineIcon size={20} className="text-gray-400" data-id="element-2013" />
              </div>
            </div>
            <button onClick={handleScan} disabled={isScanning} className={`
                bg-[#8DC63F] hover:bg-[#7AB929] text-white py-2 px-4 rounded flex items-center justify-center
                ${isScanning ? 'opacity-70 cursor-not-allowed' : ''}
              `} data-id="element-2014">
              <span data-id="element-2015">{isScanning ? 'Scanne...' : 'Scannen'}</span>
            </button>
          </div>
          {scanSuccess === false && <div className="flex items-center text-red-600 mt-2" data-id="element-2016">
              <AlertCircleIcon size={16} className="mr-1" data-id="element-2017" />
              <span data-id="element-2018">{errorMessage}</span>
            </div>}
        </div>
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-2019">
          <h4 className="font-medium text-gray-700 mb-2" data-id="element-2020">Hinweis:</h4>
          <p className="text-sm text-gray-600" data-id="element-2021">
            Scannen Sie den QR-Code des Lagerplatzes, um die Lagerverwaltung zu
            starten. Sie können dann auswählen, wo Kisten platziert werden
            sollen.
          </p>
          <p className="text-sm text-gray-600 mt-2" data-id="element-2022">
            Für Testzwecke können Sie "TKL-A1-01" eingeben.
          </p>
        </div>
      </div>
    </div>;
}